import { useContext } from 'react';
import { inputTypeContext } from './context';

export const useInputType = () => {
  const type = useContext(inputTypeContext);
  return type;
};
